import StripeEmbeddedComponentsController from "../../../../../frontend/controllers/payment/stripe_connect/embedded_components/stripe_embedded_components_controller";
import { useCompleteCollectionOptions } from "../../../../helpers/stripe_connect/embedded_components/collection_options_helper";

// Connects to data-controller="notification-banner"
export default class extends StripeEmbeddedComponentsController {
  connect() {
    this.componentConfigurations.push(
      ...[useCompleteCollectionOptions, this.#defineNotificationChangeBehaviour]
    );

    super.connect();
  }

  get componentType() {
    return "notification-banner";
  }

  #defineNotificationChangeBehaviour = (notificationBannerComponent) => {
    notificationBannerComponent.setOnNotificationsChange(
      this.#handleNotificationsChange
    );
  };

  // https://docs.stripe.com/connect/supported-embedded-components/notification-banner?lang=ruby#configure-custom-banner-behavior
  #handleNotificationsChange = (response) => {
    this.element.style.display = response.total > 0 ? "block" : "none";
  };
}
